import axios from 'axios';
import { message } from 'antd';
import { axiosApiInstance } from '../../services/axiosApiInstance';

const api = `${process.env.REACT_APP_API_URL}`;
const endpoint = {
    "getNetworksData": "/api/v1/networks/list-all-networks",
    "applyWirelessConfig": "/api/v1/networks/apply-config",
    "streamConfigResult": "/api/v1/networks/stream-config-result"
}

async function getNetworksData() {
    try {
        const getItem = await axiosApiInstance.get(`${api + endpoint['getNetworksData']}`);
        return getItem?.data
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response && error.response.data.detail) {
                if (error.response.status !== 401) {
                    const msg = error.response.data.detail
                    message.error(msg, 5);
                }
            }
        } else {
            message.error("Some errors occurred", 5);
        }
    }
}

async function applyWirelessConfig(siteId: Array<string>, config: any) {
    try {
        const resp = await axiosApiInstance.post(
            `${api + endpoint['applyWirelessConfig']}`,
            {
                siteIdToApply: siteId,
                config: config
            }
        );

        return resp?.data
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response && error.response.data.detail) {
                if (error.response.status !== 401) {
                    const msg = error.response.data.detail
                    message.error(msg, 5);
                }
            }
        } else {
            message.error("Some error occurred", 5);
        }
    }
}

function streamConfigResult(id: string) {
    const streamApi = `${api + endpoint['streamConfigResult']}?id=${id}`;

    return streamApi
    // try {
    //     const getItem = await axiosApiInstance.get();
    //     return getItem?.data
    // } catch (error) {
    //     if (axios.isAxiosError(error)) {
    //         if (error.response && error.response.data.detail) {
    //             if (error.response.status !== 401) {
    //                 const msg = error.response.data.detail
    //                 message.error(msg, 5);
    //             }
    //         }
    //     } else {
    //         message.error("Some error occurred", 5);
    //     }
    // }
}

export {
    getNetworksData,
    applyWirelessConfig,
    streamConfigResult
}